<template>
  <v-navigation-drawer
    id="contentDrawer"
    app
    floating
    class="elevation-0"
    height="auto"
    width="286px"
    right
    v-model="drawerContent"
  >
    <course-content
      :course-id="this.$route.params.courseId"
      @classChanged="$emit('classChanged')"
    ></course-content>
  </v-navigation-drawer>
</template>

<script>
import menu from "~/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import CourseContent from "./course/CourseContent";

export default {
  name: "app-drawer",
  components: {
    CourseContent,
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    miniBase: false,
    drawerContent: false,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160,
    },
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/m.png";
    },
    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },
  },
  created() {
    window.getApp.$on("APP_DRAWER_CONTENT_TOGGLED", () => {
      this.drawerContent = !this.drawerContent;
    });
  },
  mounted() {
    this.drawerContent = this.$vuetify.breakpoint.xs ? false : true;
  },
};
</script>

<style lang="scss">
#contentDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 64px);
    width: 100%;
    overflow: auto;
  }
}

.v-list__tile__content {
  &:hover {
    text-decoration: none;
  }
}
</style>
